import {connect} from "react-redux";
import {getSendOtp, getAvailability, getValidateOtp} from "../../../../actions/action";
import {getggLabTestListAction} from "../../../../actions";
import Availability from '../component/Availability';
import { Toaster, Intent, Position } from '@blueprintjs/core';


const mapStateToProps = state =>{

    return{
    }
}

const mapDispatchToProps = dispatch =>{
    return{
        getPincodeAvailability : (obj) =>{
            return getAvailability(obj)
                .catch((error) => {
                    if (error.response && error.response.status !== 401) {
                        Object.keys(error.response.data.error).forEach((key) => {
                            error.response.data.error[key].forEach((error) => {
                                Toaster.create({position: Position.TOP}).show({
                                    message: error,
                                    intent: Intent.DANGER
                                });
                            });
                        });
                    }
                });
        },

        sendOtp : (obj) =>{
            return getSendOtp(obj)
                .catch((error) => {
                    if (error.response && error.response.status !== 401) {
                        Object.keys(error.response.data.error).forEach((key) => {
                            error.response.data.error[key].forEach((error) => {
                                Toaster.create({position: Position.TOP}).show({
                                    message: error,
                                    intent: Intent.DANGER
                                });
                            });
                        });
                    }
                });
        },

        validateOtp : (obj) =>{
            return getValidateOtp(obj)
                .catch((error) => {
                    if (error.response && error.response.status !== 401) {
                        Object.keys(error.response.data.error).forEach((key) => {
                            error.response.data.error[key].forEach((error) => {
                                Toaster.create({position: Position.TOP}).show({
                                    message: error,
                                    intent: Intent.DANGER
                                });
                            });
                        });
                    }
                });
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Availability)